import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight } from "lucide-react";
import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { fetchBlogs, SITE_URL } from "@/lib/api";

const STATIC = [
  { to: "/", label: "Home" },
  { to: "/blogs", label: "Blogs" },
  { to: "/premium", label: "Become Pro" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Usage" },
  { to: "/child-safety", label: "Child Safety Standards" },
  { to: "/help", label: "Help & Contact" },
  { to: "/careers", label: "Careers" },
];

export default function Sitemap() {
  const { data: blogs = [] } = useQuery({ queryKey: ["blogs"], queryFn: fetchBlogs });
  return (
    <section className="max-w-4xl mx-auto px-5 sm:px-8 pt-32 sm:pt-36 pb-16 sm:pb-28" data-testid="sitemap-page">
      <SEO title="Sitemap | TruCitizen" description="All pages on the TruCitizen website." path="/sitemap" />
      <Reveal>
        <p className="eyebrow mb-4">Sitemap</p>
        <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-[var(--ink)]">Every page, one place.</h1>
        <div className="mt-12 grid sm:grid-cols-2 gap-10">
          <div>
            <p className="eyebrow !text-[var(--green)] mb-4">Pages</p>
            <ul className="space-y-3">{STATIC.map((l) => <li key={l.to}><Link to={l.to} className="font-semibold text-[var(--ink)] hover:text-[var(--saffron-deep)]" data-testid={`sitemap-link-${l.to.replace(/\//g, "") || "home"}`}>{l.label}</Link></li>)}</ul>
          </div>
          <div>
            <p className="eyebrow !text-[var(--green)] mb-4">Blogs</p>
            <ul className="space-y-3">{blogs.map((b) => <li key={b.id}><Link to={`/blogs/${b.slug}`} className="font-semibold text-[var(--ink)] hover:text-[var(--saffron-deep)]">{b.title}</Link></li>)}</ul>
          </div>
        </div>
        <a href={`${SITE_URL}/api/sitemap.xml`} target="_blank" rel="noopener noreferrer" className="btn-ghost mt-12 text-sm" data-testid="sitemap-xml-link">XML sitemap for search engines <ArrowUpRight size={14} /></a>
      </Reveal>
    </section>
  );
}
